import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import ComboFclty from "../../components/inputs/ComboFclty";
import {
  getSysFcltyDeptDetail,
  postSysFcltyDeptDetail,
  putSysFcltyDeptDetail
} from "../../api/apiClient";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';

const RegFcltyDept = ({
                        propPicNo,
                        hClose
                      }) => {

  const [fcltyDeptInfo, setFcltyDeptInfo] = useState({
    fclty_no: '',	// 시설고유번호
    pic_job: '',    // 담당업무
    pic_nm: '',    // 담당자명
    pic_telno: '',    // 전화번호
  });

  /* 갱신 */
  const updateDetail = () => {
    if (propPicNo != null) {
      getSysFcltyDeptDetail(propPicNo)
          .then((res) => {
                if (res.data.data !== undefined) {
                  setFcltyDeptInfo(res.data.data);
                }
              }
          );
    }
  };

  useEffect(() => {
    updateDetail();
  }, [])

  const onChangeInfo = (name, value) => {
    let newInfo = {...fcltyDeptInfo};
    newInfo[name] = value;
    setFcltyDeptInfo(newInfo);
  };

  const onSubmit = () => {
    if (fcltyDeptInfo.fclty_no === '') {
      Swal.fire(
          '시설은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (fcltyDeptInfo.pic_nm === '') {
      Swal.fire(
          '담당자명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (fcltyDeptInfo.pic_job === '') {
      Swal.fire(
          '담당업무은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (fcltyDeptInfo.pic_telno === '') {
      Swal.fire(
          '전화번호는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (propPicNo == null) {
      postSysFcltyDeptDetail(fcltyDeptInfo)
          .then((res) => {
            let data = res.data;
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      putSysFcltyDeptDetail(fcltyDeptInfo)
          .then((res) => {
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
  };

  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'gateway-register-form py-3'}
                      id={'gatewayRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <ComboFclty
                            propLabel={"시설명"}
                            propOnChange={(e) => {
                              onChangeInfo('fclty_no', e.target.value);
                            }}
                            propLabelRatio={4}
                            propDefaultValue={fcltyDeptInfo.fclty_no}
                            propLocation={"FIELD"}
                            propValue={fcltyDeptInfo.fclty_no}
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Group as={Row} controlId='formIp2Addr'>
                          <Form.Label column md={4} className={'label text-end fw-bold'}>
                            <span className={"text-danger"}>* </span>담당자명
                          </Form.Label>
                          <Col md={8}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                onChange={(e) => {
                                  onChangeInfo('pic_nm', e.target.value);
                                }}
                                // defaultValue={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_nm : '' || ''}
                                value={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_nm : '' || ''}
                                required
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group as={Row} controlId='formIp2Addr'>
                          <Form.Label column md={4} className={'label text-end fw-bold'}>
                            <span className={"text-danger"}>* </span>담당업무
                          </Form.Label>
                          <Col md={8}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                onChange={(e) => {
                                  onChangeInfo('pic_job', e.target.value);
                                }}
                                // defaultValue={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_job : '' || ''}
                                value={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_job : '' || ''}
                                required
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group as={Row} controlId='formIp2Addr'>
                          <Form.Label column md={4} className={'label text-end fw-bold'}>
                            <span className={"text-danger"}>* </span>전화번호
                          </Form.Label>
                          <Col md={8}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                onChange={(e) => {
                                  onChangeInfo('pic_telno', e.target.value);
                                }}
                                // defaultValue={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_telno : '' || ''}
                                value={(fcltyDeptInfo !== null) ? fcltyDeptInfo.pic_telno : '' || ''}
                                required
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn save-btn w-100'}
                        onClick={onSubmit}
                >저장</Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
              </Col>
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default RegFcltyDept;
